import { useEffect, useState } from "react";
import SettingLayout from "../SettingLayout";
import {
  RazorCheckBox,
  RazorToggleSlide,
} from "../../../../components/razor-reuse";
import { useDispatch, useSelector } from "react-redux";
import {
  getNotificationSettings,
  updateNotificationSettings,
} from "../../../../redux/settings";
import type { AppDispatch } from "../../../../redux/store";
import RootState, { notificationProp } from "../../../../redux/type";

const NotificationIndex = () => {
  const { loading_notification, notification_pref, mutation_notification } =
    useSelector((state: RootState) => state.settings);
  const [notificationdata, setNotificationdata] = useState<notificationProp[]>(
    []
  );
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    setNotificationdata(notification_pref as notificationProp[]);
  }, [notification_pref]);

  useEffect(() => {
    dispatch(getNotificationSettings({}) as any);
  }, [dispatch]);

  const handleToggle = (
    categoryIndex: number,
    componentIndex: number,
    type: "in_app" | "email"
  ) => {
    setNotificationdata((prevSettings) =>
      prevSettings.map((category, catIdx) => {
        if (catIdx !== categoryIndex) return category;

        return {
          ...category,
          components: category.components.map((component, compIdx) => {
            if (compIdx !== componentIndex) return component;

            return {
              ...component,
              [type]: !component[type],
            };
          }),
        };
      })
    );
  };

  const handleToggleAll = (categoryIndex: number, checked: boolean) => {
    setNotificationdata((prevSettings) =>
      prevSettings.map((category, catIdx) => {
        if (catIdx !== categoryIndex) return category;

        return {
          ...category,
          components: category.components.map((component) => {
            return {
              ...component,
              // [type]: component[type] === 1 ? 0 : 1,
              in_app: !checked,
              email: !checked,
            };
          }),
        };
      })
    );
  };

  const handleSubmit = () => {
    // console.log(notificationdata);
    dispatch(updateNotificationSettings(notificationdata) as any);
  };

  return (
    <>
      <SettingLayout
        hideBtnIcon
        onBtnClick={handleSubmit}
        title="Notification"
        pageLoading={loading_notification}
        btnLabel="Save Changes"
        btnLoading={mutation_notification}
      >
        <section className="space-y-[20px] w-4/5">
          {notificationdata?.map((cat, categoryIndex: number) => {
            // Check if all checkboxes in this category are selected
            const allChecked = cat?.components?.every(
              (component) => component?.in_app && component?.email
            );
            if (
              cat?.components?.length === 0 ||
              cat?.category === "Settings Module Notification"
            ) {
              return <> </>;
            }
            return (
              <section key={categoryIndex} className="bg-white">
                <header className="py-[10px] px-[20px] bg-[#F8F9FF] w-full flex items-center space-x-[16px] text-[#162238]">
                  <h4 className="text-[16px] font-medium w-3/5">
                    {cat?.category}
                  </h4>
                  <div className="w-2/5 grid grid-cols-4 text-center items-center">
                    <p className="text-[12px]">In App</p>
                    <p className="text-[12px]">Email</p>
                    <div className="justify-end col-span-2 items-center grid">
                      <RazorToggleSlide
                        checked={allChecked}
                        onChange={() => {
                          !mutation_notification &&
                            cat?.category !== "Settings Module Notification" &&
                            handleToggleAll(categoryIndex, allChecked);
                        }}
                        color={`black-light`}
                        id={`${cat?.category}` as any}
                      />
                    </div>
                  </div>
                </header>
                <main className="py-[26px] px-[20px] border border-[#E5E9EB] bg-[#FDFDFD] space-y-[16px]">
                  {cat?.components?.map((component, componentIndex: number) => (
                    <div
                      key={component?.name}
                      className="w-full flex items-center space-x-[16px] text-black"
                    >
                      <h4 className="text-[14px] w-3/5">
                        {componentIndex + 1}. {component?.name}.
                      </h4>
                      <div className="w-2/5 grid grid-cols-4 text-center items-center">
                        <p className="mx-auto">
                          <RazorCheckBox
                            checked={component?.in_app}
                            onChange={() =>
                              !mutation_notification &&
                              cat?.category !==
                                "Settings Module Notification" &&
                              handleToggle(
                                categoryIndex,
                                componentIndex,
                                "in_app"
                              )
                            }
                            id={`${component?.name} inapp` as any}
                            color="black-light"
                          />
                        </p>
                        <p className="mx-auto">
                          <RazorCheckBox
                            checked={component?.email}
                            onChange={() =>
                              !mutation_notification &&
                              cat?.category !==
                                "Settings Module Notification" &&
                              handleToggle(
                                categoryIndex,
                                componentIndex,
                                "email"
                              )
                            }
                            id={`${component?.name} email` as any}
                            color="black-light"
                          />
                        </p>
                      </div>
                    </div>
                  ))}
                </main>
              </section>
            );
          })}
        </section>
      </SettingLayout>
    </>
  );
};

export default NotificationIndex;
